"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.takeAllPutOne = takeAllPutOne;
var _effects = require("redux-saga/effects");
const wrapInArray = patterns => {
  return Array.isArray(patterns) ? patterns : [patterns];
};
const toPattern = patterns => {
  return new RegExp(patterns.map(pattern => `(${pattern}.*)`).join('|'));
};
function* takeAllPutOne(expectedActionTypes, actionType, action) {
  const actions = {};
  let filteredTypeTesters = expectedActionTypes.map(wrapInArray).map(toPattern);
  const allTesters = filteredTypeTesters;
  if (action) {
    actions[action.type] = action.payload;
    filteredTypeTesters = filteredTypeTesters.filter(tester => !tester.test(action.type));
  }
  while (filteredTypeTesters.length > 0) {
    const {
      type,
      payload
    } = yield (0, _effects.take)(takenAction => {
      return allTesters.some(tester => tester.test(takenAction.type));
    });
    actions[type] = payload;
    filteredTypeTesters = filteredTypeTesters.filter(tester => !tester.test(type));
  }
  yield (0, _effects.put)({
    type: actionType,
    payload: actions
  });
}